<script setup lang="ts">
import PlanSubscriptionApprovalModal from './components/plan-subscription-approval/PlanSubscriptionApprovalModal.vue';
import ScreenLoader from './components/common/ScreenLoader.vue';
import SupportDrawer from './components/support/SupportDrawer.vue';
import ToastContainer from './components/toast/ToastContainer.vue';
import ProductSuggestionsDrawer from './components/product/ProductSuggestionsDrawer.vue';
import DebugInspector from './components/debug/DebugInspector.vue';
import { Head } from '@unhead/vue/components';
import ModalsContainer from './components/common/ModalsContainer.vue';
import MobileAlertModal from './components/common/MobileAlertModal.vue';
const { isLoading } = useUi();
const { currentAppName, currentAppFavicon } = useApp();
const { t } = useTranslations();

const internalLoading = ref(false);

onMounted(() => {
  setTimeout(() => {
    internalLoading.value = isLoading.value;
  }, 1000);

  if (currentAppFavicon.value) {
    document.querySelector('link[rel="icon"]')?.setAttribute('href', currentAppFavicon.value);
  }
});

watch(isLoading, (newVal) => {
  internalLoading.value = newVal;
});

watch(
  () => currentAppFavicon.value,
  (newVal) => {
    if (!newVal) return;
    document.querySelector('link[rel="icon"]')?.setAttribute('href', newVal);
  },
);

const route = useRoute();

const routeName = computed(() => {
  const appName = currentAppName.value ?? 'Cusp';
  if (route.meta.title) return `${t(route.meta.title as string)} | ${appName}`;
  //if the route doesn't have a title, check if it has a parent route with a title
  if (route.matched.find((r) => !!r.meta.title))
    return `${t(route.matched.find((r) => !!r.meta.title)?.meta.title as string)} | ${appName}`;
  //if the route doesn't have a title at all, use the app name
  return appName;
});
</script>

<template>
  <Head>
    <title>{{ routeName }}</title>
  </Head>

  <div
    v-show="internalLoading"
    class="flex size-full h-screen items-center justify-center opacity-0 transition-opacity delay-500 duration-500"
    :class="{ 'opacity-100': internalLoading }"
  >
    <div class="flex flex-col items-center justify-center gap-3">
      <ScreenLoader />
    </div>
  </div>
  <RouterView v-slot="{ Component }">
    <component v-if="!internalLoading" :is="Component"></component>
  </RouterView>

  <!-- Global components -->
  <ToastContainer />
  <SupportDrawer />
  <PlanSubscriptionApprovalModal />
  <ProductSuggestionsDrawer />
  <MobileAlertModal />
  <ModalsContainer />
  <DebugInspector />
</template>

<style lang="scss"></style>
